<template>
  <div id="chart">
    <apexchart :options="chartOptions" :series="chartSeries" type="area" height="80"></apexchart>
  </div>
</template>

<script>
import { defineComponent, toRef, watch } from 'vue';
import VueApexCharts from 'vue3-apexcharts';

export default defineComponent({
  name: 'ChartComponent',
  components: {
    apexchart: VueApexCharts
  },
  props: {
    data: {
      type: Array,
      required: true
    },
    color: {
      type: String,
      default: '#00c853',  // Default color: green
    },
  },
  setup(props) {
    const chartData = toRef(props, 'data');
    
    const chartOptions = {
      chart: {
        width: 70,
        height:100,
        type: 'area',
        sparkline: {
          enabled: true
        }
      },
      dataLabels: {
        enabled: false
      },
      fill: {
        type: 'gradient',
        gradient: {
          shadeIntensity: 1,
          opacityFrom: 0.7,
          opacityTo: 0.9,
          stops: [0, 90, 100]
        }
      },
      colors: [props.color],
      xaxis: {
        lines: {
          show: false
        },
        categories: ['', '', '', '', '', '', '']
      },
      tooltip: {
        fixed: {
          enabled: false
        },
        x: {
          show: false
        },
        y: {
          title: {
            formatter: function (seriesName) {
              return ''
            }
          }
        },
        marker: {
          show: false
        }
      }
    };

    const chartSeries = [
      {
        name: 'Series 1',
        data: chartData.value
      }
    ];

    return {
      chartOptions,
      chartSeries
    };
  }
});
</script>

<style scoped>
#chart {
  max-width: 100px;
}
</style>
